export const GET_EMAIL_NOTIFICATION_SUCCESS = "GET_EMAIL_NOTIFICATION_SUCCESS";
export const GET_EMAIL_NOTIFICATION_REQUEST = "GET_EMAIL_NOTIFICATION_REQUEST";
export const GET_EMAIL_NOTIFICATION_FAILURE = "GET_EMAIL_NOTIFICATION_FAILURE";
export const getEmailNotificationSuccess = (payload) => ({
    type: GET_EMAIL_NOTIFICATION_SUCCESS,
    payload,
});
export const getEmailNotificationRequest = () => ({
    type: GET_EMAIL_NOTIFICATION_REQUEST,
});
export const getEmailNotificationFailure = (payload) => ({
    type: GET_EMAIL_NOTIFICATION_FAILURE,
    payload,
});
